import initSlider, { positionCloseButton } from './modal.slider';

type ModalData = {
  quote: string;
  image: string;
  image_gallery: string[] | false;
  trustpilot_url: string | false;
};

// Get DOM elements
const modalTriggers = document.querySelectorAll('.fb-references__item') as NodeListOf<HTMLElement>;
const modal = document.getElementById('reference-modal');
const modalInner = modal.querySelector('.reference-modal__inner');

/**
 * Generate multitple image elements based on a list urls
 *
 * @param  {string[]} urls
 * @returns string contains multitple image elements
 */
function generateImageGallery(urls: string[]): string {
  // Create wrapper
  let returnString = '<div class="reference-modal__gallery">';

  // Loop over all urls and generate iamges
  urls.forEach((url, index) => {
    const active = index === 0 ? 'true' : 'false';
    const image = `<img class="reference-modal__image reference-modal__image--gallery" src="${url}" data-active="${active}">`;
    returnString += image;
  });

  // Close the wrapper
  returnString += '</div>';

  // Return the gallery
  return returnString;
}

/**
 * Clear and reset the modal and data
 */
function closeAndClearModal() {
  // Rest dataset
  modal.dataset.active = 'false';
  modal.dataset.isSlider = 'false';

  // Remove content
  modalInner.innerHTML = '';

  // Reset slide index
  window.currentIndex = 0;

  history.pushState('', document.title, window.location.pathname + window.location.search);
}

/**
 * Fill the modal with the data provided
 * from the dataset of o trigger element
 *
 * @param  {ModalData} data
 */
function fillModal(data: ModalData) {
  // Add new window location
  window.history.pushState('forward', null, './#imageModal');

  // Create placeholder
  let innerModalContent = '';

  // Create gallery if required
  if (data.image_gallery) {
    // Add original to the array
    data.image_gallery.unshift(data.image);

    // Construct gallery
    const gallery = generateImageGallery(data.image_gallery);

    // Add to modal
    innerModalContent += gallery;
  } else {
    // Create a single image element
    const imageElement = `<img class="reference-modal__image" src="${data.image}">`;
    innerModalContent += imageElement;
  }

  // Create truspilot link
  if (data.trustpilot_url) {
    const button = `<a class="reference-modal__button" href="${data.trustpilot_url}" target="_blank">Trustpilot review</a>`;
    innerModalContent += button;
  }

  // Create quote element
  const quoteElement = `<p class="reference-modal__quote"><span><i></i>${data.quote}</span></p>`;
  innerModalContent += quoteElement;

  // Fill modal with requested content
  modal.dataset.active = 'true';
  modalInner.innerHTML = innerModalContent;

  // Initialize the slider if needed
  if (data.image_gallery) {
    initSlider(modal);
    modal.dataset.isSlider = 'true';
  } else {
    positionCloseButton(document.querySelector('.reference-modal__image'));
  }

  // Get the height of the quote element
  const quoteHeight = document
    .querySelector('.reference-modal__quote')
    .getBoundingClientRect().height;

  document.querySelectorAll('.reference-modal__image').forEach((image: HTMLElement) => {
    // Move the images downwards on desktop,
    // and upwards on mobile
    if (window.matchMedia('( min-width:768px )').matches) {
      image.style.transform = `translate(-50%,calc(-50% + ${quoteHeight / 2}px))`;
    } else {
      image.style.transform = `translate(-50%,calc(-50% - ${quoteHeight / 2}px))`;
    }

    // Adjust image size
    image.style.maxHeight = `calc(95% - ${quoteHeight}px)`;
  });
}

/**
 * Handle the click event on modal triggers
 *
 * @param  {HTMLElement} trigger
 * @param  {MouseEvent} event
 */
function handleTriggerClick(trigger: HTMLElement, event: MouseEvent) {
  // Get the modal data from DOM element
  // and parse it
  const { modalAttr } = trigger.dataset;
  const data = JSON.parse(modalAttr) as ModalData;
  // console.log(data);

  // Fill the modal
  fillModal(data);
}

// Add click event to all references
modalTriggers.forEach((trigger) => {
  trigger.addEventListener('click', handleTriggerClick.bind(null, trigger));
});

// Add closing events
modal.addEventListener('click', (event) => {
  if (event.target === modal) {
    closeAndClearModal();
  }
});

document.addEventListener('keydown', (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    closeAndClearModal();
    return;
  }
});

window.addEventListener('popstate', (event: Event) => {
  closeAndClearModal();
});

document.getElementById('reference-modal-close-button').addEventListener('click', () => {
  closeAndClearModal();
});
